shadow$provide[323] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Scene:{enumerable:true, get:function() {
  return Scene;
}}});
var require$three = require("three");
var require$_DOT__SLASH_renderable_DOT_js = require("./renderable.js");
class MathBox extends require$three.Object3D {
  constructor() {
    super();
    this.rotationAutoUpdate = false;
    this.frustumCulled = false;
    this.matrixAutoUpdate = false;
  }
}
class Scene extends require$_DOT__SLASH_renderable_DOT_js.Renderable {
  constructor(renderer, shaders, options) {
    super(renderer, shaders, options);
    this.root = new MathBox();
    if ((options != null ? options.scene : undefined) != null) {
      this.scene = options.scene;
    }
    if (this.scene == null) {
      this.scene = new require$three.Scene();
    }
    this.pending = [];
    this.async = 0;
    this.scratch = new require$three.WebGLRenderTarget(1, 1);
    this.camera = new require$three.PerspectiveCamera();
  }
  inject(scene) {
    if (scene != null) {
      this.scene = scene;
    }
    return this.scene.add(this.root);
  }
  unject() {
    return this.scene != null ? this.scene.remove(this.root) : undefined;
  }
  add(object) {
    if (this.async) {
      return this.pending.push(object);
    } else {
      return this._add(object);
    }
  }
  remove(object) {
    this.pending = this.pending.filter(o => o !== object);
    if (object.parent != null) {
      return this._remove(object);
    }
  }
  _add(object) {
    return this.root.add(object);
  }
  _remove(object) {
    return this.root.remove(object);
  }
  dispose() {
    if (this.root.parent != null) {
      return this.unject();
    }
  }
  warmup(n) {
    return this.async = +n || 0;
  }
  render() {
    if (!this.pending.length) {
      return;
    }
    const {children} = this.root;
    const added = [];
    for (let i = 0, end = this.async, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
      const pending = this.pending.shift();
      if (!pending) {
        break;
      }
      this._add(pending);
      added.push(added);
    }
    const visible = children.map(function(o) {
      return o.visible;
    });
    children.map(o => o.visible = !Array.from(added).includes(o));
    const currentTarget = this.renderer.getRenderTarget();
    this.renderer.setRenderTarget(this.scratch);
    this.renderer.render(this.scene, this.camera);
    this.renderer.setRenderTarget(currentTarget);
    return children.map((o, i) => o.visible = visible[i]);
  }
  toJSON() {
    return this.root.toJSON();
  }
}

};